import { Dashboard } from "./interface";

export const MENU_ELEMENTS: Record<
  string,
  {
    id: string;
    name: string;
    description?: string;
    hide_on_mobile: boolean;
    has_children: boolean;
    children: Array<Dashboard>;
    hidden?: boolean;
    path?: string;
  }
> = {
  theme_mode: {
    id: "theme_mode",
    name: "THEME MODE",
    hide_on_mobile: false,
    has_children: true,
    children: [{ id: "theme_btn", name: "THEME", path: "", hide_on_mobile: false }],
  },
  try: {
    id: "try_button",
    name: "EXPERIENCE",
    hide_on_mobile: false,
    has_children: true,
    children: [
      {
        id: "seo_report",
        name: "Search Overview",
        path: "/seo_dashboard",
        hide_on_mobile: false,
        overview_image: "seo_reporting",
        point_of_interest_summary: "Reports available in this section:",
        points_of_interest: [
          { name: "SEO Overview", path: "/seo_dashboard" },
          { name: "Search Interest", path: "/seo_dashboard/search_interest_report" },
          { name: "GEO Reporting", path: "/seo_dashboard/geo_reporting" },
        ],
        // point_of_interest_summary: "Connecting Two Data Sets to Understand What Drives Traffic",
        // points_of_interest: [
        //   "View of traffic from 19 markets including top traffic-driving queries",
        //   "View of how many customers landed on a Nissan website from organic search (visits)",
        //   "View of the number of clicks on a Nissan URL from Google Search results",
        //   "View the number of impressions (which is the number of times  a Nissan URL appears in a Google Search results page viewed by a user, not including paid Google Ads)",
        // ],
      },
      {
        id: "brand_performance",
        name: "Brand Performance",
        path: "/brand_performance",
        hide_on_mobile: false,
        overview_image: "product_marketing_optimization",
        point_of_interest_summary: "Reports available in this section:",
        points_of_interest: [{ name: "Brand Performance", path: "/brand_performance" }],
      },
      {
        id: "voc_website",
        name: "E2E Voice of Customer",
        path: "/voc/customer_journey_voc",
        hide_on_mobile: false,
        overview_image: "voc",
        point_of_interest_summary: "Reports available in this section:",
        points_of_interest: [
          { name: "Customer Journey VOC", path: "/voc/customer_journey_voc" },
          { name: "VOC Website", path: "/voc/website" },
          { name: "CCS Vital Signs", path: "/ccs_vital_signs/app_ratings" },
          { name: "Quick VOC Sales", path: "/voc/quick_voc_sales" },
          { name: "Quick VOC After Sales", path: "/voc/quick_voc_after_sales" },
          { name: "CEC VOC", path: "/voc/cec_voc" },
        ],
      },
    ],
  },
  buy: {
    id: "buy_button",
    name: "SHOP",
    hide_on_mobile: false,
    has_children: true,
    children: [
      {
        id: "online_ce_performance",
        name: "Shop: Online Customer Experience",
        path: "/digital_performance",
        hide_on_mobile: false,
        overview_image: "oce_performance",
        // point_of_interest_summary: "Aggregate New Cars Online Performance Data at the Global Level",
        // points_of_interest: [
        //   "View of customer online behaviours at global, regional and market level",
        //   "View customer behaviours with all nameplates within a region/market as well as focus on just one",
        //   "Understand which customer jobs are driving most engagement.",
        //   "View the number of visitors on PACE and conversation rates for those visitors",
        // ],
        point_of_interest_summary: "Reports available in this section:",
        points_of_interest: [
          { name: "Online CE reporting", path: "/digital_performance" },
          { name: "CPO online CE", path: "/cpo_digital_performance" },
          { name: "Journey Excellence", path: "/journey_excellence/market_performance_summary" },
          { name: "OCE Digital Trend", path: "/oce_digital_trend" },
        ],
      },
      {
        id: "ecommerce",
        name: "Buy: New & Used Cars",
        path: "/ecommerce",
        hide_on_mobile: true,
        overview_image: "ecommerce",
        // point_of_interest_summary: "Ecommerce sales funnel deep dive starting from the visit to the online order",
        // points_of_interest: [
        //   "View of the sales funnel: visit, qualified visit, checkout, online order, cancellation",
        //   "View of the influence on shopping tools conversion rate",
        //   "View of the region and model level online order trendline over the selected time period",
        //   "View of the T/DS and Non T/DS leads (online orders, contact dealers etc)",
        // ],
        point_of_interest_summary: "Reports available in this section:",
        points_of_interest: [
          { name: "Ecommerce", path: "/ecommerce" },
          { name: "CPO Operational", path: "/cpo_operational" },
        ],
      },
      {
        id: "product_marketing_optimization",
        name: "Product marketing optimization",
        path: "/product_marketing_optimization",
        hide_on_mobile: false,
        overview_image: "product_marketing_optimization",
        point_of_interest_summary: "Reports available in this section:",
        points_of_interest: [{ name: "Product marketing optimization", path: "/product_marketing_optimization" }],
        //   "Comparison between customer intention and actual sales volume at grade level, for a selection of models for G5 markets, Japan and the United States",
        // points_of_interest: [
        //   "View the % difference between customer intention and sales at grade level",
        //   "View the sales price volume curve by model vs overall segment",
        //   "View the search interest by model",
        // ],
      },
    ],
  },
  use: {
    id: "use_button",
    name: "USE",
    hide_on_mobile: false,
    has_children: true,
    children: [
      {
        id: "use_ownership",
        name: "USE Ownership",
        path: "/use_ownership/overview",
        hide_on_mobile: false,
        overview_image: "ccs_vital_signs",
        point_of_interest_summary: "Reports available in this section:",
        points_of_interest: [
          { name: "User Ownership Overview", path: "/use_ownership/overview" },
          { name: "Online Account & Engagement", path: "/use_ownership/online_account_and_engagement" },
          { name: "Service Lead", path: "/use_ownership/service_lead" },
          { name: "Self Service", path: "/use_ownership/self_service" },
          { name: "CCS Vital Signs", path: "/ccs_vital_signs" },
        ],
      },
      {
        id: "ccs_vital_signs",
        name: "CCS Performance",
        path: "/ccs_vital_signs/domo",
        hide_on_mobile: false,
        overview_image: "ccs_vital_signs",
        // point_of_interest_summary: "Aggregate Multisource Data on a Rapid Growth Industry: Connected Car Services",
        // points_of_interest: [
        //   "View of engagement insights: app downloads, avg monthly users, connectivity status, enrollment",
        //   "View of revenue insights: connected business revenue, subscription and renewal ratio",
        //   "View of customer satisfaction insights: Nissan Connect apps, CCS subscription, CCS surveys, call center",
        //   "View of operational insights: data quality, top services",
        // ],
        point_of_interest_summary: "Reports available in this section:",
        points_of_interest: [
          { name: "CCS Vital Signs", path: "/ccs_vital_signs/domo" },
          { name: "CCS Monetization", path: "/ccs_vital_signs/ccs_monetization" },
        ],
      },
      // {
      //   id: "/ccs_vital_signs_monetization",
      //   name: "CCS Monetization",
      //   path: "/ccs_vital_signs/ccs_monetization",
      //   hide_on_mobile: false,
      // },

      // {
      //   id: "quick_voc_after_sales",
      //   name: "Quick VOC After Sales",
      //   path: "/voc/quick_voc_after_sales",
      //   hide_on_mobile: false,
      // },
      // {
      //   id: "cec_voc",
      //   name: "CEC VOC",
      //   path: "/voc/cec_voc",
      //   hide_on_mobile: false,
      // },
      // {
      //   id: "clv",
      //   name: "CLV Dashboard",
      //   path: "/streamlit/clv",
      //   hide_on_mobile: false,
      // },
    ],
  },
  sales: {
    id: "executive_reporting_button",
    name: "Executive Reporting",
    hide_on_mobile: false,
    has_children: true,
    children: [
      // {
      //   id: "purchase_funnel",
      //   name: "DIS",
      //   path: "/purchase_funnel_report",
      //   hide_on_mobile: true,
      //   overview_image: "purchase_funnel",
      //   point_of_interest_summary: "Trends on Mass Market Digitally Influenced Sales",
      //   points_of_interest: [
      //     "View of progress on digitally influenced sales for G1 markets",
      //     "View of sales and close rate by source compared to target sales and close rate",
      //     "View of sales and leads sources and trends",
      //     "View percentage of digitally influenced sales",
      //   ],
      // },
      {
        id: "global_ms_sales",
        name: "G-M&S Re:Ignite Control Tower",
        path: "/global_ms_sales/ignitems",
        hide_on_mobile: false,
        // overview_image: "msrp",
        point_of_interest_summary: "Reports available in this section:",
        points_of_interest: [
          { name: "Report Overview", path: "/global_ms_sales/ignitems" },
          { name: "Sales & Inventory", path: "/global_ms_sales/tier_one" },
          { name: "Marketing & Leads Generation", path: "/global_ms_sales/tier_two" },
          { name: "Marketing Performance", path: "/global_ms_sales/tier_three" },
          { name: "How to link Nissan ID to Google", path: "/faq/link_google_account?dashboard=global_ms_sales" },
          { name: "G-M&S Re:Ignite Control Handbook", path: "/global_ms_sales/handbook_pdf_page" },
        ],
      },
      {
        id: "executive_summary",
        name: "DIS & Digital Performance",
        path: "/executive_summary/dis",
        hide_on_mobile: true,
        overview_image: "msrp",
        point_of_interest_summary: "Reports available in this section:",
        points_of_interest: [
          { name: "DIS Overview", path: "/executive_summary/dis" },
          { name: "DIS Deep-Dive", path: "/purchase_funnel_report" },
          { name: "Product Performance", path: "/executive_summary/product_performance" },
          { name: "Product Performance Deep-Dive", path: "/executive_summary/product_performance_deep_dive" },
        ],
      },
      {
        id: "trim_mix_report",
        name: "Trim Mix Analysis",
        path: "/trim_mix_report",
        hide_on_mobile: false,
        point_of_interest_summary: "Reports available in this section:",
        points_of_interest: [{ name: "Trim Mix Analysis", path: "/trim_mix_report" }],
      },

      //  {
      //   id: "ignite",
      //   name: "Ignite M&S",
      //   path: "/global_ms_sales/ignitems",
      //   hide_on_mobile: true,
      // },
      // {
      //   id: "customer_journey_voc",
      //   name: "Customer Journey VOC",
      //   path: "/voc/customer_journey_voc",
      //   hide_on_mobile: false,
      // },
      // {
      //   id: "global_ms_sales",
      //   name: "Global M&S",
      //   path: "/global_ms_sales/tier_one",
      //   hide_on_mobile: true,
      // },
    ],
  },
  adhoc: {
    id: "adhoc_button",
    name: "ANALYTICS TOOLS",
    hide_on_mobile: false,
    has_children: true,
    children: [
      {
        id: "abt_data_query",
        name: "MI Query Tool",
        path: "/streamlit/abt_data_query",
        hide_on_mobile: false,
      },
      {
        id: "correspondence_mapping",
        name: "Correspondence Mapping",
        path: "/streamlit/correspondence_mapping",
        hide_on_mobile: false,
      },
      {
        id: "pricing_project",
        name: "Pricing Project",
        path: "/streamlit/pricing_project",
        hide_on_mobile: false,
      },
      {
        id: "verbatim_analysis",
        name: "Verbatim Analysis",
        path: "/streamlit/verbatim_analysis",
        hide_on_mobile: false,
      },
      {
        id: "visit_to_lead",
        name: "VISIT TO LEAD",
        path: "/streamlit/visit_to_lead_tool",
        hide_on_mobile: false,
      },
      {
        id: "serious_buyer",
        name: "SERIOUS BUYER",
        path: "/streamlit/serious_buyer",
        hide_on_mobile: false,
      },
      {
        id: "configurator-g5",
        name: "CONFIGURATOR G5",
        path: "/beta/configurator-g5",
        hide_on_mobile: false,
      },
      {
        id: "new_beta_car_configurator",
        name: "CONFIGURATOR JP",
        path: "/beta/car_configurator",
        hide_on_mobile: false,
      },
      {
        id: "configurator_nibu",
        name: "CONFIGURATOR NIBU",
        path: "/beta/configurator-nibu",
        hide_on_mobile: false,
      },
      {
        id: "lead_management_report",
        name: "LEAD PERFORMANCE REPORTING",
        path: "/lead_management_report/introduction",
        hide_on_mobile: false,
      },
    ],
  },
  archived: {
    id: "archived_button",
    name: "Archived",
    hide_on_mobile: false,
    has_children: true,
    children: [
      {
        id: "mobility_report",
        name: "C-19 mobility restrictions",
        path: "/mobility_report",
        hide_on_mobile: true,
        overview_image: "mobility_report",
        // point_of_interest_summary: "A Tool to Understand User Mobility Compares to a Pre-pandemic Baseline",
        // points_of_interest: [
        //   "Showcases changes in mobility by market which correlate with consumer confidence",
        //   "Mobility trends grouped by several categories: Retail and recreation, Transit stations, Workplace, Grocery and pharmacy, Parks, Residential",
        // ],
      },
      {
        id: "digital_customer_experience",
        name: "Digital user experience",
        path: "/digital_user_experience",
        hide_on_mobile: true,
        overview_image: "digital_customer_experience",
        // point_of_interest_summary: "User Experience Scores and Trends by Market",
        // points_of_interest: [
        //   "View of engagement insights: Engagement, Frustration, Navigation, Technical, Form scores",
        //   "View of overall  customer experience: DXS",
        // ],
      },
      {
        id: "online_to_physical_insights",
        name: "Online to physical insights",
        path: "/online_to_physical",
        hide_on_mobile: true,
        overview_image: "online_to_physical_insights",
        // point_of_interest_summary: "Tracking the Relationship Between Online Behaviours and Sales",
        // points_of_interest: [
        //   "View of cluster insights: total leads, total sales, days to sale, sales close %, days to lead, and number of visits",
        //   "View of lead quality scoring",
        //   "View of relative engagement by KBA type and relative form submission by lead type",
        //   "View of customer segments distribution",
        // ],
      },
      {
        id: "ariya_experience_monitor",
        name: "ARIYA experience monitor",
        path: "/ariya/monitor.html",
        hide_on_mobile: false,
        overview_image: "ariya",
        // point_of_interest_summary: "Real Time Data on Nissan’s First Global Vehicle Launch",
        // points_of_interest: [
        //   "View of customer visits, sources, and trends for North America, Japan, and Europe",
        //   "View insights on Virtual Car and Vehicle Landing Page",
        //   "Understand handraiser insights of top versions, colours, and cities",
        // ],
      },
      {
        id: "cxo_experiment_library",
        name: "CXO EXPERIMENT LIBRARY",
        path: "/beta/cxo_experiment",
        hide_on_mobile: true,
        // point_of_interest_summary: "A Repository of Over 80 Data-led Experiments That Improve User Experience",
        // points_of_interest: [
        //   "Demonstrates what works and what doesn’t work for users",
        //   "Illustrates the positive impact of the ‘test and learn’ methodology on business KPIs",
        //   "Includes recommendations for product, sales, and marketing teams",
        // ],
      },
      {
        id: "mtm_metrics_that_matter",
        name: "MTM metrics that matter",
        path: "/mtm_metrics",
        hide_on_mobile: false,
        overview_image: "mtm_metrics_that_matter",
        // point_of_interest_summary: "Media Investment Impact Metrics on Future, In, and Near Market Data",
        // points_of_interest: [
        //   "View of Near market insights: media investment, paid media impressions, reach, search interest",
        //   "View of Future market insights: cost per lead, digital leads. Digitally influenced close rate, sales",
        //   "View of Near market insights: media investment, visits, unique and returning visitors, KBA visits",
        // ],
      },
      {
        id: "midas",
        name: "Marketing Investment Dashboard",
        path: "/midas/fmi_run_rate",
        hide_on_mobile: false,
        overview_image: "midas",
        // point_of_interest_summary: "",
        // points_of_interest: ["", "", "", ""],
      },
      {
        id: "dmeo",
        name: "DMEO",
        path: "/dmeo",
        hide_on_mobile: false,
      },
      {
        id: "clv",
        name: "CLV Dashboard",
        path: "/streamlit/clv",
        hide_on_mobile: false,
      },
      {
        id: "search_interest",
        name: "Search interest",
        path: "/search_interest",
        hide_on_mobile: true,
        overview_image: "search_interest",
        // point_of_interest_summary:
        //   "Demand and Traffic Indicators: Market Level Customer Search Behaviour Data View of how 18 markets are searching for Nissan’s competitors",
        // points_of_interest: [
        //   "View of car body type search and interest trends",
        //   "View of key events impacting search interest",
        //   "Competitor search interest trends",
        // ],
      },
      {
        id: "product_performance",
        name: "Product Performance",
        path: "/product_performance",
        hide_on_mobile: true,
        overview_image: "product_performance",
        // point_of_interest_summary: "Product Performance at a global and market level based on the user journey on the website",
        // points_of_interest: [
        //   "View of each product digital performance: visits, KBA and leads",
        //   "View of the influence on shopping tools and leads",
        //   "View of the customer experience",
        //   "View of the page performance, the bugs and error pages generated and the accessibitily",
        // ],
      },
      {
        id: "ccs_cockpit",
        name: "CCS Vital Signs",
        path: "/ccs_vital_signs/ccs_cockpit",
        hide_on_mobile: false,
      },
      {
        id: "msrp",
        name: "MSRP",
        // Real route (PrivateRoute registration, App.tsx) - unaffected by moving this from an
        // active-page link (NewPurchaseFunnelFilters.tsx's own "See MSRP" button, now removed) to
        // an Archived card; ArchivedDashboardCard.tsx's own handleOpen navigates to this same path.
        path: "/purchase_funnel_report/msrp",
        hide_on_mobile: true,
      },
    ],
  },
  profile: {
    id: "user_profile",
    name: "USER NAME",
    hide_on_mobile: false,
    has_children: true,
    children: [
      { id: "admin", name: "ADMIN", path: "/admin", hide_on_mobile: false },
      { id: "info", name: "INFO", path: "/dashboard_info", hide_on_mobile: false },
      { id: "profile_preferences", name: "PROFILE", path: "/user_profile", hide_on_mobile: false },
      { id: "logout", name: "LOGOUT", path: "/logout", hide_on_mobile: false },
    ],
  },
};

export const ALL_PATHS: string[] = [
  "/home",
  "/favourites",
  "/dashboards",
  "/analytics",
  "/settings",
  "/faq",
  "/alerts",
  "/archived",
  "/login",
  "/logout",
  "/sign_up",
  "/forgotten_password",
  "/set-password",
  "/welcome",
  "/403",
  "/404",
  "/invalid_token",
  "/user_profile",
  "/digital_performance",
  "/cpo_digital_performance",
  "/oce_digital_trend",
  "/data_info",
  "/dashboard_info",
  "/ccs_vital_signs/domo",
  "/ccs_vital_signs/ccs_cockpit",
  "/ccs_vital_signs/app_ratings",
  "/ccs_vital_signs/data_quality",
  "/ccs_vital_signs/ccs_journey",
  "/ccs_vital_signs/ccs_journey/europe_activation",
  "/ccs_vital_signs/top_flop",
  "/ccs_vital_signs/ccs_analysis",
  "/ccs_vital_signs/ccs_monetization",
  "/data_info",
  "/dashboard_info",
  "/release_notes",
  "product_marketing_optimization",
  "/purchase_funnel",
  "/purchase_funnel/diagnostic",
  "/purchase_funnel/msrp",
  "/mobility_report",
  "/mobility_report/insights",
  "/online_to_physical",
  "/mtm_metrics",
  "/search_interest",
  "/digital_user_experience",
  "/digital_user_experience_core_models",
  "/beta/car_configurator",
  "/beta/configurator-g5",
  "/beta/configurator-nibu",
  "/admin",
  "/seo_dashboard",

  "/ariya/monitor",
  "/ariya/experience",
  "/ariya/handraisers/market-split",
  "/ariya/handraisers",
  "/ariya/preorder/japan",
  "/ariya/preorder/norway",
  "/ariya/preorder/united-states",
  "/ariya/preorder",
  "/midas",
  "/cpo_operational",
  "/product_performance",
  "/voc",
  "/ecommerce",
  "/journey_excellence",
  "/use_ownership",
  "brand_performance",
  "/executive_summary",
  "/dmeo",
  "/lead_management_report",
  "/global_ms_sales",
  "/trim_mix_report",
  "/visit_to_lead_tool",
  "/serious_buyer",
  "/clv",
  "/streamlit",
  "/global_ms_sales/ignitems",
];
